// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","pageTitle":"_10458e17LmTazdhyubUHbR","subsecTitle":"awsHe69hU-BLE3ZLKgM5z","paymentMethodContainer":"_2t-QxeO8on6KF6hO62bi-E"};